var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.pubInfo.pubName
        ? _c("div", { staticClass: "detail-header" }, [
            _c("img", {
              attrs: {
                src: _vm.pubInfo.images[0].url,
                height: "300",
                width: "400",
              },
            }),
            _c(
              "div",
              { staticStyle: { "margin-left": "16px" } },
              [
                _c("div", {
                  staticClass: "detail-title",
                  domProps: { innerHTML: _vm._s(_vm.pubInfo.pubName) },
                }),
                _vm._l(_vm.pubInfo.tags, function (item, index) {
                  return _c("span", { key: index }, [
                    _vm._v("\n\t\t\t\t" + _vm._s(item) + "\n\t\t\t\t"),
                    index !== _vm.pubInfo.tags.length - 1
                      ? _c("span", [_vm._v("|")])
                      : _vm._e(),
                  ])
                }),
                _c("div", {
                  staticClass: "detail-hint",
                  domProps: { innerHTML: _vm._s(_vm.pubInfo.specials) },
                }),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          loading: _vm.isLoading,
                          size: "medium",
                          type: "warning",
                        },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.onDetailDeal(1)
                          },
                        },
                      },
                      [_vm._v("\n\t\t\t\t\t立即投保\n\t\t\t\t")]
                    ),
                    !_vm.isJiaDian(_vm.insureType)
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              loading: _vm.isLoading,
                              size: "medium",
                              type: "primary",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.onDetailDeal(2)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t投保计划书\n\t\t\t\t")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.pubInfo.professionDownload &&
                _vm.pubInfo.professionDownload.show === 1
                  ? _c(
                      "div",
                      { staticStyle: { "margin-top": "15px" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-top": "5px" },
                            attrs: {
                              loading: _vm.isLoading,
                              icon: "el-icon-download",
                              size: "medium",
                              type: "text",
                            },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.onDetailDeal(3)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t" +
                                _vm._s(_vm.pubInfo.professionDownload.label) +
                                "\n\t\t\t\t"
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm.pubDetail.detailModels
        ? _c(
            "el-tabs",
            {
              model: {
                value: _vm.currentStep,
                callback: function ($$v) {
                  _vm.currentStep = $$v
                },
                expression: "currentStep",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "保险详情", name: "0" } },
                [
                  _vm.pubDetail.notices
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.pubDetail.notices,
                          function (itemData, index) {
                            return _c("el-alert", {
                              key: index,
                              staticStyle: { "margin-bottom": "10px" },
                              attrs: {
                                closable: false,
                                type: itemData.type,
                                "show-icon": "",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "title",
                                    fn: function () {
                                      return [
                                        _c("span", {
                                          staticClass: "u-font-weight-bold",
                                          domProps: {
                                            innerHTML: _vm._s(itemData.content),
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            })
                          }
                        ),
                        1
                      )
                    : _vm._e(),
                  _vm.pubDetail.searchForms
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        _vm._l(
                          _vm.pubDetail.searchForms,
                          function (ref, index) {
                            var label = ref.label
                            var type = ref.type
                            var key = ref.key
                            var options = ref.options
                            if (options === void 0) options = []
                            var placeholder = ref.placeholder
                            return _c(
                              "div",
                              { staticStyle: { margin: "15px 20px" } },
                              [
                                _c(
                                  "span",
                                  { staticStyle: { "margin-right": "20px" } },
                                  [_vm._v(_vm._s(label) + "：")]
                                ),
                                type === "select"
                                  ? _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: placeholder },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onChangeSelect(key)
                                          },
                                        },
                                        model: {
                                          value: _vm.searchData[key],
                                          callback: function ($$v) {
                                            _vm.$set(_vm.searchData, key, $$v)
                                          },
                                          expression: "searchData[key]",
                                        },
                                      },
                                      _vm._l(options, function (ref) {
                                        var label1 = ref.label
                                        var value1 = ref.value
                                        return _c("el-option", {
                                          key: value1,
                                          attrs: {
                                            label: label1,
                                            value: value1,
                                          },
                                        })
                                      }),
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          }
                        ),
                        0
                      )
                    : _vm._e(),
                  _vm._l(_vm.pubDetail.detailModels, function (ref, index) {
                    var content = ref.content
                    return _c("el-card", { key: index }, [
                      _c("div", { domProps: { innerHTML: _vm._s(content) } }),
                    ])
                  }),
                ],
                2
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "常见问题", name: "1" } },
                [
                  _c(
                    "el-card",
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 16 } },
                            _vm._l(
                              _vm.pubDetail.productQas,
                              function (ref, index) {
                                var question = ref.question
                                var answer = ref.answer
                                return _c(
                                  "div",
                                  { key: index },
                                  [
                                    _c("span", {
                                      staticClass: "answer-custom answer-title",
                                      staticStyle: { "font-weight": "bold" },
                                      domProps: { innerHTML: _vm._s(question) },
                                    }),
                                    _c(
                                      "div",
                                      { staticStyle: { "margin-top": "10px" } },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "answer-custom answer-content",
                                          staticStyle: { "margin-top": "10px" },
                                          domProps: {
                                            innerHTML: _vm._s(answer),
                                          },
                                        }),
                                      ]
                                    ),
                                    _c("el-divider"),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.isLibaoGuzhu(_vm.insureType)
                      ? "特别约定"
                      : "投保须知",
                    name: "2",
                  },
                },
                [
                  _c(
                    "el-card",
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 22 } }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.pubDetail.declareContent),
                              },
                            }),
                            _c("div", {
                              staticStyle: { "margin-top": "20px" },
                              domProps: {
                                innerHTML: _vm._s(_vm.pubDetail.specialAppoint),
                              },
                            }),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.pubDetail.attachments && _vm.pubDetail.attachments.length > 0
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "下载", name: "3" } },
                    [
                      _c("avue-crud", {
                        ref: "crud_content",
                        attrs: {
                          data: _vm.pubDetail.attachments,
                          option: _vm.downloadOptionData,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "menu",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "center",
                                        width: "100%",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            icon: "el-icon-download",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.onDownload(row)
                                            },
                                          },
                                        },
                                        [_vm._v("下载")]
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2354213775
                        ),
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.clauseDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "保险条款", name: "4" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(_vm.pubDetail.clauseDesc),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.productDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "产品说明", name: "5" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.pubDetail.productDesc
                                    ),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.claimDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "理赔须知", name: "6" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(_vm.pubDetail.claimDesc),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.dutyExemptDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "责任免除", name: "7" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.pubDetail.dutyExemptDesc
                                    ),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.disclosureDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "信息披露", name: "8" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.pubDetail.disclosureDesc
                                    ),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.pubDetail.personalInfoProtectDesc
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "个人信息保护政策", name: "9" } },
                    [
                      _c(
                        "el-card",
                        [
                          _c(
                            "el-row",
                            [
                              _c("el-col", { attrs: { span: 22 } }, [
                                _c("div", {
                                  staticStyle: { "margin-top": "20px" },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.pubDetail.personalInfoProtectDesc
                                    ),
                                  },
                                }),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }